<template>
  <div>
    <back-button default-to="/buy-backs"/>
    <b-card no-header>
      <div class="d-flex mb-2">
        <b-button-group class="add-button-group ml-auto">
          <b-btn v-if="approvalStatus === 'approved'" variant="primary" type="button" @click="downloadInvoice"><font-awesome-icon icon="file-pdf"/> Cetak Invoice</b-btn>
        </b-button-group>
      </div>
      <b-row>
        <b-col cols="12" md="6" class="mb-1">
          <div>
            <div>
              <label for="nama" class="form-label mb-2">
                Penjual
              </label>
            </div>
            <span v-if="costumer" style="cursor: pointer;" @click.prevent="$refs.costumerDetailModal.openModal(costumer.id)">
              <div class="d-flex flex-wrap">
                <div class="mb-2 mr-2"><strong>Nama</strong>: {{ costumer.nama}}</div><div class="mb-2 mr-2">, <strong>No. HP</strong>: {{ costumer.no_hp }}</div><div class="mb-2" v-if="costumer.nik">, <strong>NIK</strong>: {{ costumer.nik }}</div>
              </div>
            </span>
          </div>
        </b-col>
        <div class="col-md-6 col-12"><div><div class="mb-3"><label class="form-label w-100" style="font-size: 80%;">No. Invoice</label><p class="heading-color">{{ transaction_no }}</p></div></div></div>
        <b-col cols="12" md="6" v-for="(m, index) in filterBuyBackModel(['tanggal_transaksi', 'metode_pembayaran'])"  :key="'buy_back_model_1_ ' + index">
          <div>
            <detail-group-input :ref="index" :type="m.type" :label="typeof m.label === 'string' ? m.label : null" :need-label="true" v-model="m.value" :id="index" :skipPriceTag="index === 'berat'" />
          </div>
        </b-col>
      </b-row>
      <div class="mt-2 mb-3">
        <form-detail ref="formDetail" :model="detailModel" mode="detail" :rows="details" colTotlalName="harga_modal" />
      </div>
      <div v-if="details.length" class="table-responsive mb-3">
        <table class="table table-sm"><thead><tr><th>Barang</th><th>Keputusan</th><th>Status Proses</th></tr></thead><tbody>
          <tr v-for="row in details" :key="'status-' + row.id"><td>{{ row.nama }}</td><td>{{ row.disposition === 'display' ? 'Pajang' : (row.disposition === 'melt' ? 'Lebur' : 'Belum dipilih') }}</td><td><b-badge :variant="itemStatusVariant(row)">{{ itemStatusLabel(row) }}</b-badge></td></tr>
        </tbody></table>
      </div>
      <b-alert :show="approvalStatus === 'draft' || approvalStatus === 'pending'" variant="warning">
        Data buy back menunggu persetujuan pemilik/owner. Data belum masuk stok dan laporan.
      </b-alert>
      <div v-if="isAdmin && approvalStatus === 'pending'" class="border rounded p-3 mb-3">
        <h6>Persetujuan Buy Back</h6>
        <p class="text-muted">Persetujuan ini belum menambah stok. Keputusan lebur/pajang dilakukan pada tahap berikutnya.</p>
        <b-button variant="success" :disabled="isLoading" @click="approve">Setujui Buy Back</b-button>
        <b-button variant="warning" class="ml-2" :disabled="isLoading" @click="returnForRevision">Kembalikan ke Draft</b-button>
        <b-button variant="danger" class="ml-2" :disabled="isLoading" @click="reject">Tolak</b-button>
      </div>
      <div v-if="isAdmin && approvalStatus === 'approved' && dispositionStatus === 'pending'" class="border rounded p-3 mb-3">
        <h6>Keputusan Per Item</h6>
        <div class="table-responsive">
          <table class="table table-sm table-striped">
            <thead>
              <tr><th>Barang</th><th>Berat</th><th>Kadar</th><th>Keputusan</th><th>Stok Existing / Harga Jual Baru</th></tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in approvalRows" :key="row.id">
                <td>{{ row.nama }}</td>
                <td>{{ row.berat }} gr</td>
                <td>{{ row.kadar }}</td>
                <td>
                  <b-form-select v-model="row.stock_action" :options="approvalOptions" @change="loadStocks(index)" />
                </td>
                <td v-if="row.stock_action === 'existing'">
                  <b-form-select v-model="row.stock_id" :options="stockOptions[index] || []" />
                </td>
                <td v-else-if="row.stock_action === 'new'"><b-form-input v-model="row.harga_jual" type="number" min="0" placeholder="Harga jual" /></td>
                <td v-else class="text-muted">Tidak diperlukan</td>
              </tr>
            </tbody>
          </table>
        </div>
        <b-button variant="success" :disabled="isLoading || !allDecided" @click="saveDisposition">Simpan Keputusan</b-button>
      </div>
      <div v-if="approvalStatus === 'approved'" class="border rounded p-3 mb-3">
        <h6>Foto Pajang</h6>
        <div v-for="row in details" :key="row.id" class="d-flex align-items-center mb-2">
          <span class="mr-3">{{ row.nama }} — {{ row.disposition === 'melt' ? 'Lebur' : (row.photo_status === 'completed' ? 'Foto sudah diunggah' : 'Menunggu foto') }}</span>
          <b-button v-if="row.disposition === 'display' && row.photo_status !== 'completed'" size="sm" variant="primary" @click="openPhotoModal(row)">Upload Foto Pajang</b-button>
        </div>
      </div>
      <div class="mt-2 mb-3">
        <b-row>
          <b-col cols="12" md="12" v-for="(m, index) in filterBuyBackModel(['catatan'])"  :key="'buy_back_model_3_ ' + index">
            <div>
              <detail-group-input :ref="index" :type="m.type" :label="typeof m.label === 'string' ? m.label : null" :need-label="true" v-model="m.value" :id="index" :skipPriceTag="index === 'berat'" />
            </div>
          </b-col>
        </b-row>
      </div>
      <div>
          <b-button v-if="canEditDraft" variant="primary" class="mr-2" :disabled="isLoading" @click="submitForApproval">Ajukan Persetujuan</b-button>
          <b-button v-if="canEditDraft" :to="'/buy-backs/' + $route.params.id + '/edit'" variant="secondary" class="mt-0">Ubah</b-button>
        <b-button :to="'/buy-backs/'" variant="secondary" class="ml-3 float-right">Kembali</b-button>
      </div>
    </b-card>
    <costumer-detail-modal ref="costumerDetailModal" title="Detail Data Penjual"/>
    <b-modal ref="photoModal" title="Upload Foto Pajang" @ok="uploadPhoto" ok-title="Simpan Foto" cancel-title="Batal">
      <div v-if="photoRow" class="mb-2"><div><strong>{{ photoRow.nama }}</strong></div><div>Jenis: {{ photoRow.jenis_barang }} · Berat: {{ photoRow.berat }} gr · Kadar: {{ photoRow.kadar }}</div><div>Keputusan: Pajang</div></div>
      <div v-if="photoRow && photoRow.foto" class="mb-2"><small>Foto lama</small><br><img :src="photoRow.foto" alt="Foto lama" style="max-width:180px;max-height:120px"></div>
      <b-form-file v-model="photoFile" accept="image/*" placeholder="Pilih foto baru" />
      <img v-if="photoPreview" :src="photoPreview" alt="Preview foto baru" class="mt-2" style="max-width:240px;max-height:160px">
    </b-modal>
  </div>
</template>

<script>
import { setModelValue, Roles } from '@/_helpers'
import detailGroupInput from '@/components/DetailGroupInput.vue'
import costumerDetailModal from '@/pages/Costumer/DetailModal.vue'
import BuyBack from '@/models/BuyBack.js'
import formDetail from '@/components/FormDetail';
import BuyBackDetail from '@/models/BuyBackDetail.js'
import Stock from '@/models/Stock.js'
import axios from 'axios'

const buyBackModel = new BuyBack()
const buyBackDetailModel = new BuyBackDetail()
const stockModel = new Stock()

export default {
  components: {
    detailGroupInput,
    costumerDetailModal,
    formDetail
  },
  watch: {
    photoFile (file) { this.photoPreview = file ? URL.createObjectURL(file) : null },
    '$route.params.id': function (val) {
      if (val !== undefined) {
        this.getDetail()
      }
    }
  },
  data () {
    return {
      Roles: Roles,
      isLoading: false,
      transaction_no: null,
      costumer: null,
      details: [],
      approvalRows: [],
      stockOptions: {},
      approvalStatus: null,
      dispositionStatus: null,
      createdBy: null,
      photoRow: null,
      photoFile: null,
      photoPreview: null,
      approvalOptions: [
        { value: null, text: 'Pilih keputusan' },
        { value: 'existing', text: 'Pajang - Gunakan stok yang ada' },
        { value: 'new', text: 'Pajang - Buat stok baru' },
        { value: 'melt', text: 'Lebur' }
      ],
      model: buyBackModel.init(),
      detailModel: buyBackDetailModel.init(),
      apiUrl: {
        buyBack: buyBackModel.endpoint
      },
    }
  },
  mounted () {
    this.getDetail()
  },
  computed: {
    isAdmin () {
      return this.$store.getters['account/accountData'].role === Roles.ADMIN
    },
    isCreator () {
      return Number(this.createdBy) === Number(this.$store.getters['account/accountData'].id)
    },
    canEditDraft () {
      return this.approvalStatus === 'draft' && this.isCreator
    },
    allDecided () {
      return this.approvalRows.length > 0 && this.approvalRows.every(row => row.stock_action && (row.stock_action !== 'existing' || row.stock_id) && (row.stock_action !== 'new' || row.harga_jual !== null))
    }
  },
  methods: {
    filterBuyBackModel (search, type = 'include') {
      const filtered = Object.entries(this.model).filter(mdl => {
        return type === 'include' ? search.includes(mdl[0]) : !search.includes(mdl[0])
      });
      let result = {}
      filtered.forEach(element => {
        result[element[0]] = element[1];
      });
      return result;
    },
    filterModel (search) {
      const filtered = Object.entries(this.model).filter(mdl => {
        return search.includes(mdl[0])
      });
      let result = {}
      filtered.forEach(element => {
        result[element[0]] = element[1];
      });
      return result;
    },
    async getDetail () {
      this.isLoading = true
      try {
        const resp = await buyBackModel.find(this.$route.params.id);
        this.costumer = resp.costumer;
        this.details = resp.detail_barang;
        this.approvalStatus = resp.approval_status || 'approved'
        this.dispositionStatus = resp.disposition_status || null
        this.createdBy = resp.created_by
        this.approvalRows = this.details.map(row => ({
          ...row,
          stock_action: row.stock_action || null,
          stock_id: row.stock_id || null
        }))
        this.transaction_no = resp.transaction_no;
        setModelValue(this.model, resp);
      }
      catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.error(e)
        }
      }

      this.isLoading = false
    },
    loadStocks (index) {
      const row = this.approvalRows[index]
      if (row.stock_action !== 'existing') {
        this.$set(this.stockOptions, index, [])
        row.stock_id = null
        return
      }
      stockModel.list({ nama_barcode: row.nama, limit: 100 }).then(response => {
        const options = [{ value: null, text: 'Pilih stok' }]
        ;(response.data || []).forEach(stock => {
          if (String(stock.kadar) === String(row.kadar) && (stock.jenis_barang || 'emas') === (row.jenis_barang || 'emas')) {
            options.push({ value: stock.id, text: stock.nama + ' · ' + (stock.stock_balance || stock.sisa_stok) + ' ' + (stock.inventory_unit || 'buah') })
          }
        })
        this.$set(this.stockOptions, index, options)
      })
    },
    approve () {
      if (this.approvalStatus === 'pending') {
        this.isLoading = true
        buyBackModel.approve(this.$route.params.id).then(response => { this.approvalStatus = response.approval_status; this.dispositionStatus = response.disposition_status; this.$store.dispatch('notification/success', 'Buy back berhasil disetujui.') }).catch(error => this.$store.dispatch('notification/error', error)).finally(() => { this.isLoading = false })
        return
      }
    },
    saveDisposition () {
      const decisions = this.approvalRows.map(row => ({ id: row.id, disposition: row.stock_action === 'melt' ? 'melt' : 'display', stock_action: row.stock_action === 'melt' ? null : row.stock_action, stock_id: row.stock_action === 'existing' ? row.stock_id : null, new_stock: row.stock_action === 'new' ? { harga_jual: row.harga_jual } : null }))
      if (decisions.some(row => row.stock_action === 'existing' && !row.stock_id)) {
        this.$store.dispatch('notification/error', 'Pilih stok existing untuk setiap barang yang menggunakannya')
        return
      }
      this.isLoading = true
      buyBackModel.setDisposition(this.$route.params.id, decisions).then(response => {
        this.approvalStatus = response.approval_status; this.dispositionStatus = response.disposition_status
        this.details = response.detail_barang
        this.approvalRows = this.details
        this.$store.dispatch('notification/success', 'Keputusan lebur/pajang berhasil disimpan.')
      }).catch(error => this.$store.dispatch('notification/error', error)).finally(() => {
        this.isLoading = false
      })
    },
    openPhotoModal (row) { this.photoRow = row; this.photoFile = null; this.photoPreview = null; this.$refs.photoModal.show() },
    itemStatusLabel (row) { if (!row.disposition) return 'Menunggu Keputusan'; if (row.disposition === 'melt') return 'Selesai Lebur'; return row.photo_status === 'completed' ? 'Selesai Pajang' : 'Menunggu Foto Pajang' },
    itemStatusVariant (row) { return !row.disposition ? 'secondary' : (row.photo_status === 'completed' || row.disposition === 'melt' ? 'success' : 'warning') },
    uploadPhoto (bvModalEvt) {
      bvModalEvt.preventDefault(); if (!this.photoFile || !this.photoRow) return
      this.isLoading = true; buyBackModel.uploadPhoto(this.$route.params.id, this.photoRow.id, this.photoFile).then(response => { this.details = response.detail_barang; this.dispositionStatus = response.disposition_status; this.$refs.photoModal.hide(); this.$store.dispatch('notification/success', 'Foto pajang berhasil disimpan dan stok diaktifkan.') }).catch(error => this.$store.dispatch('notification/error', error)).finally(() => { this.isLoading = false })
    }
    ,submitForApproval () {
      this.isLoading = true
      buyBackModel.submit(this.$route.params.id).then(response => {
        this.approvalStatus = response.approval_status
        this.$store.dispatch('notification/success', 'Buy back berhasil diajukan.')
      }).catch(error => this.$store.dispatch('notification/error', error)).finally(() => {
        this.isLoading = false
      })
    }
    ,downloadInvoice () {
      axios.get(this.apiUrl.buyBack + '/' + this.$route.params.id + '?print_pdf=1', { responseType: 'blob' }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
        const link = document.createElement('a')
        link.href = url
        link.download = 'Kwitansi-Buy-Back.pdf'
        link.click()
        window.URL.revokeObjectURL(url)
      }).catch(error => this.$store.dispatch('notification/error', error))
    }
    ,reject () {
      const reason = window.prompt('Alasan penolakan wajib diisi')
      if (!reason) return
      this.isLoading = true
      buyBackModel.reject(this.$route.params.id, reason).then(response => { this.approvalStatus = response.approval_status; this.$store.dispatch('notification/success', 'Buy back ditolak.') }).catch(error => this.$store.dispatch('notification/error', error)).finally(() => { this.isLoading = false })
    },
    returnForRevision () {
      const reason = window.prompt('Alasan pengembalian wajib diisi'); if (!reason) return
      this.isLoading = true
      buyBackModel.returnForRevision(this.$route.params.id, reason).then(response => { this.approvalStatus = response.approval_status; this.$store.dispatch('notification/success', 'Buy back dikembalikan ke Draft.') }).catch(error => this.$store.dispatch('notification/error', error)).finally(() => { this.isLoading = false })
    }
  }
}
</script>
